import { render, staticRenderFns } from "./TabellaAvanzamentoConfirmation.vue?vue&type=template&id=61b69786&scoped=true&"
import script from "./TabellaAvanzamentoConfirmation.vue?vue&type=script&lang=js&"
export * from "./TabellaAvanzamentoConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b69786",
  null
  
)

export default component.exports